<div class="main-container">
  <form [formGroup]="userForm">
    @if (viewType === 'Add') {
      <!-- Header Section -->
      <div class="page-header">
        <div class="routing-buttons">
          <div
            class="action-button back-button"
            (click)="navigateBackToList()"
            tabindex="0"
            (keydown.enter)="navigateBackToList()"
          >
            <mat-icon class="icon back-icon">arrow_back</mat-icon>
          </div>
          <div
            class="action-button reload-button"
            (click)="userFormSwitch(userId)"
            tabindex="0"
            (keydown.enter)="userFormSwitch(userId)"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
          <span class="page-title"> User Management</span>
        </div>
      </div>

      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">
            @if (submitButton) {
              Save User Details
            }
            @if (updateButton) {
              Update User Details
            }
          </h6>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <form [formGroup]="userForm" novalidate>
          <div class="flex-body">
            <div class="image-section">
              @if (!profilePicture) {
                <div>
                  <img
                    loading="lazy"
                    src="../../assets/profile.png"
                    alt="Profile Picture"
                  />
                </div>
              }
              @if (profilePicture) {
                <div>
                  <img
                    loading="lazy"
                    [src]="profilePicture"
                    alt="Profile Picture"
                  />
                </div>
              }
              <input
                #fileUpload
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                style="display: none"
                (change)="onChange($event)"
              />
              <button type="button" (click)="fileUpload.click()">
                Upload Profile Picture
              </button>
            </div>
            <div class="image-form-section">
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    formControlName="firstName"
                    placeholder="First Name"
                    required
                  />
                  @if (
                    userForm.controls['firstName'].touched &&
                    userForm.controls['firstName'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['firstName'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['firstName'].touched &&
                    userForm.controls['firstName'].errors
                      ?.nonNumericNoSpecialChars
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['firstName'].errors
                          ?.nonNumericNoSpecialChars
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input
                    matInput
                    formControlName="lastName"
                    placeholder="Last Name"
                    required
                  />
                  @if (
                    userForm.controls['lastName'].touched &&
                    userForm.controls['lastName'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['lastName'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['lastName'].touched &&
                    userForm.controls['lastName'].errors
                      ?.nonNumericNoSpecialChars
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['lastName'].errors
                          ?.nonNumericNoSpecialChars
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-select
                    #roleSelect
                    formControlName="userRole"
                    (selectionChange)="onRoleChange($event)"
                  >
                    @if (roleSelect.focused) {
                      <mat-option>
                        <ngx-mat-select-search
                          placeholderLabel="Filter"
                          [formControl]="userRoleNameFilterCtrl"
                          [noEntriesFoundLabel]="'No options found'"
                          (filteredReturn)="filteredListOfRoles = $event"
                          onkeydown="return (event.keyCode!=13)"
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                    }
                    @for (item of filteredListOfRoles; track item) {
                      <mat-option [value]="item.userRole">
                        {{ item.userRole }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-label>User Type</mat-label>
                  @if (
                    userForm.controls['userRole'].touched &&
                    userForm.controls['userRole'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['userRole'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    type="email"
                    placeholder="User Email"
                    formControlName="customerEmail"
                    required
                  />
                  @if (
                    userForm.controls['customerEmail'].touched &&
                    userForm.controls['customerEmail'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['customerEmail'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['customerEmail'].touched &&
                    userForm.controls['customerEmail'].errors?.validEmail
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['customerEmail'].errors?.validEmail
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Mobile Number</mat-label>
                  <input
                    matInput
                    type="email"
                    placeholder="Mobile Number"
                    formControlName="mobileNumber"
                    required
                  />
                  @if (
                    userForm.controls['mobileNumber'].touched &&
                    userForm.controls['mobileNumber'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['mobileNumber'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                  @if (
                    userForm.controls['mobileNumber'].touched &&
                    userForm.controls['mobileNumber'].errors
                      ?.mobileNumberValidation
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['mobileNumber'].errors
                          ?.mobileNumberValidation
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>Country</mat-label>
                  <input
                    matInput
                    formControlName="country"
                    placeholder="Country"
                    required
                  />
                  @if (
                    userForm.controls['country'].touched &&
                    userForm.controls['country'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['country'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-group">
                <mat-form-field appearance="outline">
                  <mat-label>State</mat-label>
                  <input
                    matInput
                    formControlName="addressState"
                    placeholder="State"
                    required
                  />
                  @if (
                    userForm.controls['addressState'].touched &&
                    userForm.controls['addressState'].errors
                      ?.requiredAndNoEmptySpaces
                  ) {
                    <mat-error>
                      {{
                        userForm.controls['addressState'].errors
                          ?.requiredAndNoEmptySpaces
                      }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              @if (updateButton) {
                <div class="form-group">
                  <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select
                      required
                      class="colorblack"
                      formControlName="status"
                    >
                      <mat-option value="Active">Active</mat-option>
                      <mat-option value="In-active">In-active</mat-option>
                    </mat-select>
                    @if (
                      userForm.controls['status'].touched &&
                      userForm.controls['status'].errors
                        ?.requiredAndNoEmptySpaces
                    ) {
                      <mat-error>
                        {{
                          userForm.controls['status'].errors
                            ?.requiredAndNoEmptySpaces
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              }
            </div>
          </div>
        </form>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section -->
        <div class="component-footer">
          <div class="button-group">
            @if (submitButton && userCreate) {
              <button
                type="button"
                class="submit-button"
                (click)="addUserDetails()"
              >
                Save User Details
                <mat-icon class="btn-icon">check_circle</mat-icon>
              </button>
            }
            @if (updateButton && userUpdate) {
              <button
                type="button"
                class="edit-button"
                (click)="updateUserDetails()"
              >
                Update User Details <mat-icon class="btn-icon">edit</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
    }
    @if (viewType === 'List') {
      <!-- Header Section -->
      <div class="page-header">
        <div class="routing-buttons">
          <div
            class="action-button back-button"
            (click)="navigateBack()"
            tabindex="0"
            (keydown.enter)="navigateBack()"
          >
            <mat-icon class="icon back-icon">arrow_back</mat-icon>
          </div>
          <div
            class="action-button reload-button"
            (click)="ngOnInit()"
            tabindex="0"
            (keydown.enter)="ngOnInit()"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
          <span class="page-title"> User Management</span>
        </div>
        <div class="button-group">
          @if (userCreate) {
            <button
              class="primary-button"
              type="button"
              (click)="userFormSwitch(userId)"
            >
              Add User <mat-icon class="btn-icon">open_in_new</mat-icon>
            </button>
          }
        </div>
      </div>
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">User List</h6>
          <div class="component-actions">
            <app-common-component-dropdown-search
              [items]="roleFilterList"
              [initialValue]="filterSelect"
              [placeHolder]="'Select Role'"
              (itemSelected)="filterSelected($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              [initialSearchValue]="searchText"
              matTooltip="Full Name | Email"
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <tr>
              <th>Full Name</th>
              <th>Email</th>
              <th>Mobile No.</th>
              <th>User Role</th>
              <th>Role Type</th>
              <th>Hierarchy Level</th>
              <th>Group Name</th>
              <th>Status</th>
              @if (userUpdate || userDelete) {
                <th colspan="2">Action</th>
              }
            </tr>
            @if (listOfUsers.length !== 0) {
              <tbody>
                @for (
                  user of listOfUsers
                    | paginate
                      : {
                          id: 'user_pagination',
                          itemsPerPage: size,
                          currentPage: page,
                          totalItems: totalLength,
                        };
                  track user
                ) {
                  <tr>
                    <td>
                      {{
                        user.firstName
                          ? user.firstName + ' ' + user.lastName
                          : '--'
                      }}
                    </td>
                    <td>
                      {{ user.customerEmail ? user.customerEmail : '--' }}
                    </td>
                    <td>
                      {{ user.mobileNumber ? user.mobileNumber : '--' }}
                    </td>
                    <td>
                      {{ user.userRole ? user.userRole : '--' }}
                    </td>
                    <td>
                      {{ user.roleType ? user.roleType : '--' }}
                    </td>
                    <td>
                      {{ user.hierarchyLevel ? user.hierarchyLevel : '--' }}
                    </td>
                    <td>
                      {{
                        user.groupId?.groupName ? user.groupId?.groupName : '--'
                      }}
                    </td>
                    <td>
                      {{ user.status ? user.status : '--' }}
                    </td>

                    <td>
                      <div class="action-buttons">
                        @if (userUpdate) {
                          <button
                            type="button"
                            class="primary-button view-button"
                            (click)="fetchUserDetails(user._id)"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                        }
                        @if (userDelete) {
                          <button
                            type="button"
                            class="primary-button delete-button"
                            [disabled]="user.status !== 'Active'"
                            (click)="delete(user._id)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (listOfUsers.length === 0) {
              <tbody>
                <tr>
                  <td colspan="10">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (listOfUsers.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalLength"
              [pageSize]="size"
              [currentPage]="page"
              [totalPages]="totalLength"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }
  </form>
</div>
